import 'styled-components/macro';
import 'scroll-shadow-element';
import { FC, HTMLAttributes } from 'react';
import { styled, theme } from 'twin.macro';

const ShadowContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  overflow: hidden;

  /* See: https://github.com/ingmarh/scroll-shadow-element#configuration */
  scroll-shadow {
    height: 100%;
    width: 100%;

    --scroll-gradient-from: rgba(0 0 0 / 30%);
    --scroll-gradient-to: transparent;

    --scroll-shadow-size: 20;
    --scroll-shadow-top: linear-gradient(to bottom, var(--scroll-gradient-from), var(--scroll-gradient-to));
    --scroll-shadow-bottom: linear-gradient(to top, var(--scroll-gradient-from), var(--scroll-gradient-to));
    --scroll-shadow-left: linear-gradient(to right, var(--scroll-gradient-from), var(--scroll-gradient-to));
    --scroll-shadow-right: linear-gradient(to left, var(--scroll-gradient-from), var(--scroll-gradient-to));
  }
`;

const ShadowScrollArea = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;

  /* Scrollbar */
  --scrollbarBG: transparent;
  --thumbBG: ${theme`colors.green.DEFAULT`};

  scrollbar-width: thin;
  scrollbar-color: var(--thumbBG) var(--scrollbarBG);

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: var(--scrollbarBG);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--thumbBG);
    border-radius: 6px;
    border: 3px solid var(--scrollbarBG);
  }
  /* End scrollbar */
`;

export const ShadowScrollContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...rest }) => (
  <ShadowContainer {...rest}>
    <scroll-shadow>
      <ShadowScrollArea>{children}</ShadowScrollArea>
    </scroll-shadow>
  </ShadowContainer>
);
